<template>
    <div>
        <draggable v-model="value" @start="drag=true" @end="drag=false" ghost-class="alert-primary" v-if="value && value.length != 0">
            <div v-for="(campo, index) in value" :key="index" class="form-row pt-2 border rounded mx-1" :class="campo.color ? 'table-' + campo.color : 'table-light'">
                <div class="col col-12 col-md-1">
                    <div class="form-group">
                    <div class="input-group d-flex flex-column">
                        <button
                        data-toggle="collapse" 
                        :data-target="'#grupo' + index"
                        class="btn btn-outline-primary btn-sm"
                        type="button"
                        id="button-addon1"
                        >{{ index + 1 }}</button>
                    </div>
                    </div>
                </div>
                <!-- Campo Tipo -->
                <div class="col col-12 col-md-2" v-if="!dd">
                    <select class="form-control form-control-sm" v-model="campo.type">
                        <option :value="undefined" disabled>Tipo...</option>
                        <option value="text">Texto Curto</option>
                        <option value="textarea">Texto Longo</option>
                        <option value="rich">Texto Rico</option>
                        <option value="label">Texto Fixo</option>
                        <option value="cid">CID-10</option>
                        <option value="cid11">CID-11</option>
                        <option value="number">Número</option>
                        <option value="number2">Par de Números</option>
                        <option value="select">Lista de Seleção</option>
                        <option value="checkbox">Caixa de Seleção</option>
                        <option value="checkbox-group">Caixa de Seleção Compacta</option>
                        <option value="radio-h">Radio Horizontal</option>
                        <option value="radio-v">Radio Vertical</option>
                        <option value="title">Título</option>
                        <option value="subtitle">Subtítulo</option>
                        <option value="group">Grupo</option>
                        <option value="tabela">Tabela</option>
                        <option value="list">Lista de Itens</option>
                        <option value="computed">Cálculo</option>
                        <option value="date">Data</option>
                        <option value="time">Hora</option>
                        <option value="datetime-local">Data/Hora</option>
                        <option value="page-break">Quebra de Página</option>
                        <option value="audiograma">Audiograma</option>
                        <option value="imitancia-acustica">Imitância Acústica</option>
                        <option value="grafico-pediatria">Gráfico Pediatria</option>
                        <option value="imagembase">Imagem Marcável</option>
                        <option value="link">Link</option>
                        <option value="qrcode">QRCode</option>
                    </select>
                </div>

                <div class="col col-12 col-md-2" v-else>
                    <select class="form-control form-control-sm" v-model="campo.type" v-if="!index">
                        <option :value="undefined" disabled>Tipo...</option>
                        <option value="checkbox">Botão</option>
                        <option value="checkbox-group">Opção em Lista</option>
                    </select>
                    <template v-else-if="exibir_limite_ausencia(campo)">
                        <az-input sizing="sm" type="text" placeholder="Limite (Db) ausência..." v-model="campo.limite" />
                    </template>
                </div>

                <!-- Fim Campo Tipo -->
                <template v-if="campo.type == 'page-break'">
                    <div class="col col-12 col-md-8">
                    </div>
                </template>
                <template v-else>
                    <div class="col col-12 col-md-2">
                        <div class="form-group">
                            <div class="input-group">
                                <input
                                type="text"
                                class="form form-control form-control-sm"
                                :class="!campo.label ? 'bg-warning' : ''"
                                v-model="campo.label"
                                placeholder="Título..." />
                                <div class="input-group-append">
                                    <span class="input-group-text px-1" v-if="campo.estilo == 'E'" title="Título na esquerda.">
                                        <i class="fa-solid fa-arrow-left"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col col-12 col-md-2">
                        <select class="form form-control form-control-sm" v-model="campo.width" v-if="!dd">
                            <option :value="undefined" disabled>Largura</option>
                            <option value="12">100%</option>
                            <option value="1">8%(1/12)</option>
                            <option value="2">16%(1/6)</option>
                            <option value="3">25%(1/4)</option>
                            <option value="4">33%(1/3)</option>
                            <option value="5">42%(5/12)</option>
                            <option value="6">50%(1/2)</option>
                            <option value="7">58%(7/12)</option>
                            <option value="8">66%(2/3)</option>
                            <option value="9">75%(3/4)</option>
                            <option value="10">84%(5/6)</option>
                            <option value="11">92%(11/12)</option>
                        </select>

                        <div class="input-group mb-0" v-else>
                            <div class="input-group-prepend" v-if="campo.icone">
                                <span class="input-group-text" id="basic-addon1">
                                    <i :class="campo.icone" aria-hidden="true"></i>
                                </span>
                            </div>
                            <input
                                type="text"
                                class="form form-control form-control-sm"
                                v-model="campo.icone"
                                placeholder="Ícone..." />
                        </div>
                    </div>
                    <template v-if="campo.type == 'audiograma'">
                        <div class="col col-12 col-md-4">
                            <select class="form form-control form-control-sm" v-model="campo.ouvido" v-if="campo.type != 'label'">
                                <option value="OD">OD - Ouvido Direito</option>
                                <option value="OE">OE - Ouvido Esquerdo</option>
                                <option value="AO">Ambos</option>
                                <option value="CL">Campo Livre</option>
                            </select>
                        </div>
                    </template>
                    <template v-else-if="campo.type == 'grafico-pediatria'">
                        <div class="col col-12 col-md-4">
                            <select class="form form-control form-control-sm" v-model="campo.grafico">
                                <option value="1" v-if="false">Crescimento - 0 a 6 meses</option>
                                <option value="2">Crescimento - 0 a 2 anos</option>
                                <option value="3">Crescimento - 0 a 5 anos</option>
                                <option value="4">Crescimento - 2 a 5 anos</option>
                                <option value="5" v-if="false">Peso por Idade - 0 a 6 meses</option>
                                <option value="6">Peso por Idade - 0 a 2 anos</option>
                                <option value="7">Peso por Idade - 6 meses a 2 anos</option>
                                <option value="8">Peso por Idade - 2 a 5 anos</option>
                                <option value="9">Peso por Idade - 0 a 5 anos</option>
                                <option value="10">Peso por Tamanho - 0 a 2 anos</option>
                                <option value="11">Peso por Tamanho - 2 a 5 anos</option>
                                <option value="12">Índice de Massa Corporal por Idade - 0 a 5 anos</option>
                                <option value="13">Índice de Massa Corporal por Idade - 2 a 5 anos</option>
                                <option value="14">Índice de Massa Corporal por Idade - 0 a 5 anos</option>
                                <option value="15">Cincunferencia da Cabeça por Idade - 0 a 13 semanas</option>
                                <option value="16">Cincunferencia da Cabeça por Idade - 0 a 2 anos</option>
                                <option value="17">Cincunferencia da Cabeça por Idade - 0 a 5 anos</option>
                                <option value="18">Cincunferencia do Braço por Idade - 3 meses a 5 anos</option>
                                <option value="19">Dobra Cutânea Subescapular - 3 meses a 5 anos</option>
                                <option value="20">Dobra Cutânea do Tríceps - 3 meses a 5 anos</option>
                            </select>
                        </div>
                    </template>
                    <template v-else-if="mode == 'print'">
                        <div class="col col-12 col-md-2">
                            <select class="form form-control form-control-sm" v-model="campo.id" placeholder="Id" v-if="campo.type != 'label'">
                                <option value="">Selecione...</option>
                                <option :value="id_val" v-for="(id_val, id_idx) in lista_ids" :key="id_idx">{{ id_val }}</option>
                            </select>
                        </div>
                        <div class="col col-12 col-md-1">
                            <select class="form form-control form-control-sm" v-model="campo.estilo" v-if="campo.type != 'label'">
                                <option value="C">Titulo/Cima</option>
                                <option value="E">Título/Esquerda</option>
                            </select>
                        </div>
                        <div class="col col-12 col-md-1">
                            <select class="form form-control form-control-sm" v-model="campo.imp_vazio" placeholder="Quando vazio..." v-if="campo.type != 'label'">
                                <option value="">Selecione...</option>
                                <option value="N">Ocultar se vazio</option>
                                <option value="S">Manter se vazio</option>
                            </select>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col col-12 col-md-2">
                            <div class="input-group input-group-sm">
                                <input type="text" class="form form-control form-control-sm"
                                    v-model="campo.value" placeholder="Valor Padrão"/>
                                <div class="input-group-append">
                                    <button class="btn btn-sm btn-outline-secondary" type="button" id="button-addon2"
                                        data-toggle="tooltip" data-placement="right" title="Indicação de campo editável."
                                        @click="set_edit(campo)">
                                        <i class="fa-solid fa-pen-slash fa-fw" v-if="campo.ne"></i>
                                        <i class="fa-solid fa-pen fa-fw" v-else></i>
                                    </button>
                                    
                                    <button class="btn btn-sm btn-outline-secondary" type="button" id="button-addon2"
                                        data-toggle="tooltip" data-placement="right" title="Indicação de campo requerido."
                                        @click="set_required(campo)">
                                        <i class="far fa-registered" v-if="campo.required"></i>
                                        <i class="fa fa-circle-o" aria-hidden="true" v-else></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col col-12 col-md-2">
                            <select class="form form-control form-control-sm"
                                v-model="campo.color"
                                v-if="campo.type == 'title' || campo.type == 'subtitle' || campo.type == 'group' || campo.type == 'tabela' || campo.type == 'list'">
                                <option value="">Nenhuma</option>
                                <option value="primary">Azul</option>
                                <option value="info">Azul Claro</option>
                                <option value="success">Verde</option>
                                <option value="secondary">Cinza</option>
                                <option value="warning">Amarela</option>
                                <option value="danger">Vermelha</option>
                            </select>
                            <input type="text" class="form form-control form-control-sm" v-model="campo.id" placeholder="Id" v-else-if="campo.type != 'label'" />
                            <small class="text-muted" v-else>{{ campo.id }}</small>
                        </div>
                    </template>
                </template>

                <div class="col col-12 col-md-1">
                    <div class="form-group">
                        <!-- <label v-if="!index">#</label> -->
                        <div class="input-group d-flex flex-column">
                            <div class="btn-group" role="group" aria-label="Basic example">
                                <button class="btn btn-outline-secondary btn-sm mr-1" type="button" id="button-addon2"
                                    data-toggle="tooltip" data-placement="left" title="Configuração de visibilidade do campo."
                                    @click="controle_visibilidade (campo)" v-if="mode != 'print'">
                                    <i class="fas fa-eye"></i>
                                </button>
                                <div class="dropdown">
                                    <button class="btn btn-sm btn-outline-secondary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="#" @click.prevent="excluirCampo (index)">
                                            <i class="fas fa-times mr-2"></i>
                                            Remover
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="incluirCampo(index + 1)">
                                            <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                            Incluir
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="recortarItem(index)">
                                            <i class="fa-solid fa-scissors fa-fw mr-2"></i>
                                            Recortar Campo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="abrirRecortarFaixa()">
                                            <i class="fa-solid fa-scissors fa-fw mr-2"></i>
                                            Recortar Campos
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="colarItem(index)" v-if="transferencia">
                                            <i class="fa-solid fa-paste fa-fw mr-2"></i>
                                            Colar
                                        </a>

                                        <template v-if="campo.type == 'text' || campo.type == 'number'">
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" href="#" @click.prevent="incluir_dropdown(campo)">
                                                <i class="fa-regular fa-square-caret-down fa-fw mr-2"></i>
                                                Incluir Opção Associada
                                            </a>
                                        </template>

                                        <template v-if="campo.type == 'group'">
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" href="#" @click.prevent="toggle_score(campo)">
                                                <i class="fa-regular fa-star-half-stroke fa-fw mr-2"></i>
                                                <span v-if="campo.score">
                                                    Remover
                                                </span>
                                                Modelo de Score
                                            </a>
                                        </template>

                                        <template v-else>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" href="#" @click.prevent="definirCompacto(campo)">
                                                <i class="fa-solid fa-arrow-left fa-fw mr-2" v-if="campo.estilo == 'C'"></i>
                                                <i class="fa-solid fa-arrow-up fa-fw mr-2" v-else-if="campo.estilo == 'E'"></i>
                                                {{ campo.estilo == 'E' ? 'Mudar pra Título em Cima' : 'Mudar pra Título na Esquerda' }}
                                            </a>    
                                        </template>

                                        <template v-if="campo.type != 'label'">
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" href="#" @click.prevent="toggle_imp_vazio(campo)">
                                                <span v-if="campo.imp_vazio == 'S'">
                                                    <i class="fa-regular fa-circle fa-fw mr-2"></i>Manter se Vazio
                                                </span>
                                                <span v-else>
                                                    <i class="fa-solid fa-ban fa-fw mr-2"></i>Ocultar se Vazio
                                                </span>
                                            </a>    
                                        </template>

                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" href="#" @click.prevent="definirCor(campo, '')">
                                            <i class="fas fa-palette text-light mr-2"></i>
                                            Sem Cor
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="definirCor(campo, 'warning')">
                                            <i class="fas fa-palette text-warning mr-2"></i>
                                            Amarelo
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="definirCor(campo, 'primary')">
                                            <i class="fas fa-palette text-primary mr-2"></i>
                                            Azul
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="definirCor(campo, 'info')">
                                            <i class="fas fa-palette text-info mr-2"></i>
                                            Azul Claro
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="definirCor(campo, 'secondary')">
                                            <i class="fas fa-palette text-secondary mr-2"></i>
                                            Cinza
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="definirCor(campo, 'success')">
                                            <i class="fas fa-palette text-success mr-2"></i>
                                            Verde
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="definirCor(campo, 'danger')">
                                            <i class="fas fa-palette text-danger mr-2"></i>
                                            Vermelho
                                        </a>
                                    </div>
                                </div>

                                <!--
                                <button class="btn btn-outline-danger btn-sm" type="button" id="button-addon2"
                                    data-toggle="tooltip" data-placement="left" title="Remover campo."
                                    @click="excluirCampo (index)">
                                    <i class="fas fa-times"></i>
                                </button>
                                -->
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Campo Número ou Calculado -->
                <template v-if="campo.type == 'number' || campo.type == 'number2' || campo.type == 'computed'">
                    <div class="col col-4 mb-3 pl-5">
                        <az-input icon="fas fa-ruler" sizing="sm" type="text" placeholder="Unidade de Medida" v-model="campo.um" buttonToolTip="Unidade de Medida" />
                    </div>

                    <div class="col col-8 mb-3">
                        <az-input sizing="sm" type="textarea" :rows="campo.ref ? 3 : 1" placeholder="Referência" v-model="campo.ref">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">Ref</span>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </template>

                <!-- Campo Tipo Caixa de Texto -->
                <div class="col col-4 mb-3 pl-5" v-if="campo.type == 'textarea'">
                    <az-input icon="fas fa-bars" sizing="sm" type="number" v-model="campo.rows" buttonToolTip="Altera em Linhas" />
                </div>

                <!-- Campo Tipo Lista -->
                <div class="col col-12 mb-3 pl-5" v-if="campo.type == 'select' || campo.type == 'radio-h' || campo.type == 'radio-v'">
                    <az-input icon="fas fa-list" sizing="sm" type="text" v-model="campo.options" buttonToolTip="Opções, separadas por vírgula" />
                </div>

                <!-- Campo Tipo Calculo -->
                <template v-if="campo.type == 'computed'">
                    <div class="col col-8 mb-3 pl-5">
                        <az-input icon="fas fa-square-root-alt" sizing="sm" type="text" v-model="campo.expression" buttonToolTip="Fórmula: Monte a fórmula com #IDs..."/>
                    </div>

                    <div class="col col-4 mb-3">
                        <az-input icon="fas fa-hashtag" sizing="sm" type="number" v-model="campo.precision" buttonToolTip="Casas Decimais"
                            placeholder="Casas Decimais..." />
                    </div>
                </template>

                <!-- Controle de Visibilidade -->
                <template v-if="campo.v !== undefined">
                    <div class="col mb-3 pl-5" :class="campocustompaciente ? 'col-4' : 'col-8'">
                        <az-input icon="fas fa-eye" sizing="sm" type="text" v-model="campo.v" buttonToolTip="Controle de Visibilidade do Campo"/>
                    </div>

                    <div class="col col-4 mb-3">
                        <az-input type="checkbox-group" sizing="sm" v-model="campo.vs" label="Ocultar Espaço"
                            :edicao="campo.v ? true : false" />
                    </div>

                    <div class="col col-4 mb-3" v-if="campocustompaciente">
                        <az-input type="checkbox-group" sizing="sm" v-model="campo.vc" label="Exibir no Cabeçalho" />
                    </div>
                </template>

                <!-- Imagem Marcável -->
                <template v-if="campo.type == 'imagembase'">
                    <div class="col col-4 mb-3 pl-5">
                        <az-single-image-loader
                            :blockcam="true"
                            titulo="Imagem"
                            :chave="'img-' + index"
                            :parms="{
                                model_type: 'arquivo',
                                model_id: -1,
                                st_descricao: 'Imagem'
                            }"
                            :id_arquivo="campo.id_arquivo"
                            @sync="associar_imagem(campo, $event)" />
                    </div>

                    <div class="col col-8 mb-3" v-if="campo.id_arquivo && campo.marcs">
                        <div class="form-row" v-for="(marc, imx) in campo.marcs" :key="imx">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    placeholder="Título..."
                                    v-model="marc.info">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="rem_marcador(campo, imx)">
                                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    type="select"
                                    placeholder="Cor..."
                                    :optionsList="[
                                        { id: 'yellow', search: 'Amarelo' },
                                        { id: 'blue', search: 'Azul' },
                                        { id: 'cyan', search: 'Azul Ciano' },
                                        { id: 'navy', search: 'Azul Escuro' },
                                        { id: 'gray', search: 'Cinza' },
                                        { id: 'indigo', search: 'Indigo' },
                                        { id: 'orange', search: 'Laranja' },
                                        { id: 'brown', search: 'Marrom' },
                                        { id: 'olive', search: 'Oliva' },
                                        { id: 'black', search: 'Preto' },
                                        { id: 'pink', search: 'Rosa' },
                                        { id: 'purple', search: 'Roxo' },
                                        { id: 'green', search: 'Verde' },
                                        { id: 'red', search: 'Vermelho' },
                                    ]"
                                    optionsData="id"
                                    v-model="marc.cor" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    type="number"
                                    placeholder="Tamanho..."
                                    v-model="marc.tam">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">px</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>
                        <button type="button" class="btn btn-primary btn-sm" @click="add_marcador(campo)">
                            <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                        </button>

                        <az-input
                            label="Tamanho da Imagem"
                            sizing="sm"
                            type="number"
                            placeholder="Tamanho... 200..."
                            v-model="campo.t">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">px</span>
                                </div>
                            </template>
                        </az-input>

                        <pre v-if="false">{{ campo.marcs }}</pre>
                    </div>
                </template>

                <template v-if="campo.type == 'tabela'">
                    <div class="col col-12 mb-3 pl-5">
                        <az-input icon="fa-solid fa-table-columns" sizing="sm" type="text" placeholder="Colunas" v-model="campo.cols" />
                    </div>
                </template>

                <!-- Pontuação -->

                <template v-if="enquete">

                    <template v-if="campo.type == 'checkbox' || campo.type == 'checkbox-group'">
                        <div class="col col-12 col-md-2 mb-3 pl-5">
                            Pontos
                        </div>
                        <div class="col col-12 col-md-5">
                            <az-input 
                                sizing="sm"
                                icon="fa-regular fa-square-check"
                                placeholder="Pontos Marcado..."
                                v-model="campo.av_pt" />
                        </div>
                        <div class="col col-12 col-md-5">
                            <az-input 
                                sizing="sm"
                                icon="fa-regular fa-square"
                                placeholder="Pontos Não Marcado..."
                                v-model="campo.av_pf" />
                        </div>
                    </template>

                    <template v-else-if="campo.type == 'number' || campo.type == 'computed' || campo.type == 'select' || campo.type == 'radio-h' || campo.type == 'radio-v'">
                        <div class="col col-12 col-md-2 mb-3 pl-5">
                            Pontos
                        </div>
                        <div class="col col-12 col-md-10">
                            <a href="#" @click.prevent="incluir_ponto(campo)" class="btn btn-outline-primary btn-sm">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </a>
                        </div>
                        <div class="col col-12 offset-md-2" v-if="campo.av && campo.av.length">
                            <div class="form-row" v-for="(aval, iavx) in campo.av" :key="iavx">
                                <div class="col col-12 col-md-2">
                                    <az-input 
                                        sizing="sm"
                                        type="select"
                                        placeholder="Tipo..."
                                        :optionsList="[
                                            { 
                                                id: 'T', 
                                                search: 'Texto', 
                                            },
                                            { 
                                                id: 'V', 
                                                search: 'Valor', 
                                            }
                                        ]"
                                        optionsData="id"
                                        v-model="aval.tp">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button type="button" class="btn btn-outline-danger" @click="remover_ponto(campo, iavx)">
                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>

                                <div class="col col-12 col-md-6" v-if="aval.tp == 'T'">
                                    <az-input
                                        sizing="sm"
                                        placeholder="Resposta..."
                                        v-model="aval.de" />
                                </div>

                                <template v-if="aval.tp == 'V'">

                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            icon="fa-solid fa-greater-than-equal"
                                            sizing="sm"
                                            placeholder="De..."
                                            v-model="aval.de" />
                                    </div>

                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            icon="fa-solid fa-less-than-equal"
                                            sizing="sm"
                                            placeholder="Até..."
                                            v-model="aval.ate" />
                                    </div>

                                </template>

                                <div class="col col-12 col-md-2" v-if="aval.tp">
                                    <az-input
                                        sizing="sm"
                                        type="number"
                                        placeholder="Pontos..."
                                        v-model="aval.ponto">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="aval.ponto">
                                                <span class="input-group-text" id="basic-addon2">ponto(s)</span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>
                            
                        </div>
                    </template>

                </template>

                <!-- Grupo -->
                <div class="col col-12 mb-3 collapse show" :id="'grupo' + index" v-if="campo.type == 'group' || campo.type == 'list' || campo.type == 'tabela' || campo.dd">
                    <campos-config-formulario
                        :validate="validate"
                        v-model="campo.campos"
                        :enquete="enquete || ( campo.type == 'group' && campo.score )"
                        :transferencia="transferencia"
                        :base="base"
                        :mode="mode"
                        :group="true"
                        @recortar="recortar_bubble"
                        :dd="( campo.type != 'group' && campo.dd ) ? true : false" />

                    <div class="mt-3" v-if="campo.type == 'group' && campo.score">
                        <campo-score-config-aval v-model="campo.av" :validate="validate">
                            <az-input
                                label="Id"
                                :compact="true"
                                sizing="sm"
                                placeholder="Id do Campo..."
                                required
                                :validate="validate"
                                v-model="campo.id">
                            </az-input>
                        </campo-score-config-aval>
                    </div>
                </div>

            </div>
        </draggable>
        <div v-else class="alert alert-primary d-flex flex-column justify-content-center align-items-center">
            O formulário está vazio.
            <small
            class="text-black-50 text-center"
            >Aperte no botão azul para adicionar um campo</small>
        </div>
        <button v-if="group" type="button" class="btn btn-primary btn-sm mt-3 mr-2" @click="incluirCampo()">
            <i class="fas fa-plus mr-2"></i> Incluir
        </button>

        <button v-if="group && transferencia" type="button" class="btn btn-primary btn-sm mt-3" @click="colarItemGrupo()">
            <i class="fa-solid fa-paste fa-fw mr-2"></i> Colar
        </button>

        <!-- Modal -->
        <template v-if="recortar_faixa">
            <div class="modal fade" id="recortarFaixaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Recortar Faixa</h5>
                            <button type="button" class="close" @click="fechar_modal('recortarFaixaModal')" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        icon="fa-solid fa-greater-than-equal"
                                        type="number"
                                        placeholder="1"
                                        required
                                        :validate="validate"
                                        v-model="recortar_faixa.inicio" />
                                </div>

                                <div class="col col-12 col-md-6">
                                    <az-input
                                        icon="fa-solid fa-less-than-equal"
                                        type="number"
                                        placeholder="1"
                                        required
                                        :validate="validate"
                                        v-model="recortar_faixa.ate" />
                                </div>
                            </div>

                            <pre>{{ transferencia }}</pre>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="fechar_modal('recortarFaixaModal')">Cancelar</button>
                            <button type="button" class="btn btn-success" @click="recortarFaixa()">Recortar</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import draggable from "vuedraggable";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSingleImageLoader from '../../util/AzSingleImageLoader.vue';
import CampoScoreConfigAval from './CampoScoreConfigAval.vue';

export default {
    name: 'campos-config-formulario',

    data() { 
        return { 
            recortar_faixa: null, 
        }
    },

    components: {
        draggable,
        AzInput,
        AzSingleImageLoader,
        CampoScoreConfigAval, 
    },

    props: ['value', 'group', 'mode', 'base', 'campocustompaciente', 'transferencia', 'dd', 'enquete', 'validate'],

    watch: {
        value: function(newValue) {
            this.$emit("input", newValue);
        },
    },

    computed: {
        tem_campo_formula: function() {
            if ( !this.value )
                return false;

            return this.value.findIndex(item => item.type == 'computed') >= 0;
        },

        lista_ids: function() {

            if ( !this.base )
                return [];

            let campos = this.base;

            campos = campos.flatMap(x => ( x.type == 'group' || x.type == 'tabela' ) ? ( x.campos ? x.campos : [] ) : x);
            campos = campos.flatMap(x => ( x.type == 'group' || x.type == 'tabela' ) ? ( x.campos ? x.campos : [] ) : x);
            campos = campos.flatMap(x => ( x.type == 'group' || x.type == 'tabela' ) ? ( x.campos ? x.campos : [] ) : x);

            return campos.filter(item => item.id)
                    .map(item => item.id);

        }
    },

    methods: {
        fechar_modal (modal_id) {
            $('#' + modal_id).modal('hide');

            this.$nextTick(() => {
                this.recortar_faixa = null;
            });
        },

        toggle_imp_vazio (campo) { 
            if ( campo.imp_vazio == 'S' ) { 
                campo.imp_vazio = 'N'; 
            } else { 
                campo.imp_vazio = 'S';
            }
            this.$forceUpdate();
        },

        definirCompacto (campo) { 
            if ( campo.estilo == 'E' ) { 
                campo.estilo = 'C'; 
            } else { 
                campo.estilo = 'E';
            }
            this.$forceUpdate();
        },
    
        toggle_score (campo) { 
            campo.score = !campo.score;
            this.$forceUpdate();
        },

        remover_ponto(campo, idx) { 
            campo.av.splice(idx, 1);
            this.$forceUpdate();
        },

        incluir_ponto(campo) { 
            if ( !campo.av ) { 
                campo.av = [];
            }

            this.$forceUpdate();

            campo.av.push({
                tp: 'T', 
                de: "", 
                ate: "", 
                ponto: "", 
            });
        },

        exibir_limite_ausencia(campo) {
            return _.endsWith(campo.id, '-a');
        },

       incluir_dropdown (campo) {
            campo.dd = !campo.dd;

            if ( !campo.dd ) {
                delete campo.campos;
            }

            this.$forceUpdate();
        },

        rem_marcador (campo, idx) {
            campo.marcs.splice(idx, 1);
        },

        add_marcador (campo) {
            if ( !campo.marcs ) {
                campo.marcs = [];
                this.$forceUpdate();
            }

            campo.marcs.push({
                cor: "black",
                tam: 10,
            });
        },

        associar_imagem (campo, imagem) {
            if ( !campo.marcs ) {
                campo.marcs = [];
            }

            campo.id_arquivo = imagem.id_arquivo;

            this.$forceUpdate();
        },

        definirCor (campo, cor) {
            campo.color = cor;
            this.$forceUpdate();
        },

        set_edit(campo) { 
            campo.ne = !campo.ne;
            $('[data-toggle="tooltip"]').tooltip('hide');
            this.$forceUpdate();
        },

        set_required(campo) {
            campo.required = !campo.required;
            $('[data-toggle="tooltip"]').tooltip('hide');
            this.$forceUpdate();
        },

        controle_visibilidade(campo) {
            $('[data-toggle="tooltip"]').tooltip('hide');

            if ( campo.v === undefined ) {
                campo.v = "";
            } else {
                campo.v = undefined;
            }

            this.$forceUpdate();
        },

        incluirCampo(index = null, novocampo = null) {
            if ( !novocampo ) {

                if ( this.dd ) {
                    novocampo = {
                        type: "checkbox-group",
                        color: "",
                        value: false,
                    };
                } else {
                    novocampo = {
                        type: "text",
                        color: "",
                    };
                }
            }

            if ( !this.value ) {
                this.$emit('input', [novocampo]);
            } else {
                if ( index === null || isNaN(index) ) {
                    this.value.push(novocampo);
                } else {
                    this.value.splice(
                        index,
                        0,
                        novocampo
                    );
                }
            }
        },

        excluirCampo(index) {
            $('[data-toggle="tooltip"]').tooltip('hide');

            if ( !confirm("Confirma remover o campo?") )
                return;

            this.value.splice(index, 1);
        },

        recortar_bubble (conteudo) { 
            this.$emit('recortar', conteudo);
        },

        recortarItem(index) {
            $('[data-toggle="tooltip"]').tooltip('hide');

            this.$emit('recortar', _.cloneDeep(this.value[index]));

            this.value.splice(index, 1);
        },

        abrirRecortarFaixa() { 
            this.recortar_faixa = {
                inicio: 1, 
                ate: this.value.length, 
            };

            this.$nextTick(() => {
                $('#recortarFaixaModal').modal('show');
            });
        }, 

        recortarFaixa() {
            this.$emit('recortar', _.cloneDeep(this.value.slice(this.recortar_faixa.inicio - 1, this.recortar_faixa.ate)));
            this.value.splice(this.recortar_faixa.inicio - 1, this.recortar_faixa.ate - this.recortar_faixa.inicio + 1);

            $('#recortarFaixaModal').modal('hide');

            this.$nextTick(() => {
                this.recortar_faixa = null;
            });
        },

        colarItem(index) {
            if ( Array.isArray(this.transferencia) ) { 
                for ( let i = 0; i < this.transferencia.length; i++ ) { 
                    this.incluirCampo(index + i + 1, this.transferencia[i]);
                }
                return;
            } else { 
                this.incluirCampo(index + 1, this.transferencia);            
            }
        },

        colarItemGrupo() { 
            if ( Array.isArray(this.transferencia) ) { 
                for ( let i = 0; i < this.transferencia.length; i++ ) { 
                    this.value.push(this.transferencia[i]);
                }
            } else { 
                this.value.push(this.transferencia);            
            }
        }
    },

    updated () {
        $('[data-toggle="tooltip"]').tooltip();
    }
}
</script>
